import React from 'react';
import { List, InputNumber } from 'antd';
import { checkoutItemsProps } from '../../common/types';

function onChange(value: any) {
  console.log('changed', value);
}

const CheckoutListItems = (item: checkoutItemsProps) => {
  return (
    <List.Item>
      <div style={{ display: 'flex', flex: 1 }}>
        <div style={{ flex: '2 1 0', alignSelf: 'center' }}>{item.name}</div>
        <div style={{ flex: '2 1 0', alignSelf: 'center' }}>
          <InputNumber
            min={1}
            max={100000}
            defaultValue={3}
            onChange={onChange}
          />
        </div>
        <div style={{ flex: 1, alignSelf: 'center' }}>{item.amount}</div>
      </div>
    </List.Item>
  );
};

export default CheckoutListItems;
